<div class="row onetimepay-container">
  <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
    <h1
      data-cy="OTPTitleContext"
      dsContent
      [contentPath]="'billing.reviewOTPPaymentHeader'"
      [options]="(isEditOTPFlow$ | async) ? { flowName: 'Edit Your' } : { flowName: 'Review Your' }"
    ></h1>
    <h2 data-cy="OTPSubTitleContext" dsContent [contentPath]="'billing.reviewOTPSubHeader'"></h2>

    <form [formGroup]="oneTimePayForm">
      <ds-column-layout [numberOfColumns]="'three'">
        <div column-left>
          <amfam-account-list
            data-cy="accountList"
            [options]="accountListOptions$ | async"
            [linkText]="autoPaySetUpLinkText"
            [showAutoPaySetUpLink]="showAutoPaySetUpLink$ | async"
            [parentFormGroup]="oneTimePayForm"
            (setupAutopayEvent)="setupAutopay()"
            (editEvent)="editAmount($event)"
            (deleteEvent)="delete($event)"
          ></amfam-account-list>
        </div>
        <div column-center>
          <ds-setup-payment-method
            [formGroup]="oneTimePayForm"
            [paymentMethodOptions]="paymentMethodOptions"
            [displayDiscountWarning]="false"
            [displayPaymentExpiredError]="false"
            [displayAutoPayDiscountMessage]="false"
            [paymentMethodError]="paymentMethodError"
            [paymentError]="paymentError$ | async"
            [authorizedToAddPaymentMethod]="authorizedToAddPaymentMethod$ | async"
            [authorizedToEditPaymentMethod]="authorizedToEditPaymentMethod$ | async"
            (editPaymentMethodEvent)="editPaymentMethod()"
            (addCreditDebitEvent)="addCreditDebit()"
            (addCheckingAccountEvent)="addCheckingAccount()"
            (addSavingsAccountEvent)="addSavingsAccount()"
          ></ds-setup-payment-method>
        </div>
        <div column-right>
          <amfam-select-payment-date
            [formGroup]="oneTimePayForm"
            [paymentDateOptions]="paymentDateOptions"
            [hasPastDue]="hasPastDue$ | async"
            [disableRadioSelection]="
              (hasPastDue$ | async) || (hasMinDueZero$ | async) || isDueDateInPast
            "
            [matDatePickerOptions]="matDatePickerOptions"
            (datePickerChangeEvent)="dateChangeEvent($event)"
            (dateRadioChangeEvent)="dateChangeEvent($event)"
          ></amfam-select-payment-date>
        </div>
      </ds-column-layout>
    </form>
    @if (headingText && !errorBoxText) {
      <div class="pad-top-10">
        <ds-warning-box
          [headingText]="headingText"
          [messageText]="bodyText"
          [linkText]="linkText"
          (linkEvent)="alertLinkEvent($event)"
          [postLinkText]="postLinkText"
        >
        </ds-warning-box>
      </div>
    }
    @if (headingText && errorBoxText) {
      <div class="pad-top-10">
        <ds-errorbox
          [headingText]="headingText"
          [messageText]="bodyText"
          [linkText]="linkText"
          (linkEvent)="alertLinkEvent($event)"
          [postLinkText]="postLinkText"
        >
        </ds-errorbox>
      </div>
    }
    @if (oneTimePayForm) {
      <ds-payment-terms-and-conditions
        [(visible)]="showTermsAndConditionsModal"
        [isPartner]="isPartner$ | async"
        [paymentType]="termsAndConditionsType$ | async"
        [partnerContent]="termsAndConditionsPartnerContent$ | async"
        (agreeTermsAndConditionsEvent)="agreeTermsAndConditionsEvent($event)"
        data-cy="paymentTermsAndConditions"
      >
      </ds-payment-terms-and-conditions>
    }
    <hr aria-hidden="true" class="dashed" />

    <amfam-total-amount [total]="total$ | async" [date]="displayDate$ | async"></amfam-total-amount
    ><call-to-action
      [tertiaryButtonName]="'Cancel'"
      [primaryButtonName]="(isEditOTPFlow$ | async) ? 'Update Payment' : primaryButtonName"
      [disablePrimaryButton]="
        (isFormInvalid$ | async) ||
        (roleService.isAuthorized('makemyacctpayment_submit_disable') | async) === false ||
        ((isEditingAndNotChanged$ | async) &&
          isEditingAndDateNotChanged &&
          isEditingAndAmountNotChanged) ||
        isDisabledAfterClick
      "
      (primaryEvent)="submitPayment()"
      (tertiaryEvent)="cancel()"
    ></call-to-action>
  </div>
</div>

<ds-payment-method-modal
  [paymentMethodAddEditConfig]="paymentMethodAddEditConfig$ | async"
  [displayDiscountWarning]="false"
  (paymentMethodAddEditCompleteEvent)="paymentMethodAddEditComplete($event)"
>
</ds-payment-method-modal>

<amfam-choose-payment-amount-modal
  [choosePaymentAmountOptions]="choosePaymentAmountOptions"
  [defaultPaymentAmount]="defaultPaymentAmount"
  [isPastDue]="hasPastDue$ | async"
  (chooseAmountValues)="saveCustomAmountComplete($event)"
  (linkTextEvent)="linkTextEvent($event)"
>
</amfam-choose-payment-amount-modal>

<ds-alert-modal
  [config]="cancelModalConfig"
  (primaryEvent)="leave()"
  (tertiaryEvent)="stay()"
></ds-alert-modal>

<ds-alert-modal
  [config]="deleteAccountModalConfig"
  (primaryEvent)="removeAccount()"
  (tertiaryEvent)="stay()"
></ds-alert-modal>
